<template>
  <div class="page" :style="bgStyle">
    <a href="https://www.movistar.com.mx/empresas" target="_blank" class="link-sitio">https://www.movistar.com.mx/empresas</a>
    <div class="main">
      <div class="panel">
        <!-- Header: Logo -->
        <div class="panel-header">
          <img
            :src="isMobile ? '/ejecutivo/logo movil.png' : '/ejecutivo/logotipo.png'"
            alt="Movistar Empresas"
            class="panel-logo"
          />
        </div>

        <!-- ========== FORM VIEW ========== -->
        <template v-if="!registroExitoso">
          <!-- Title -->
          <h1 class="titulo"><b>Registra tus datos y en breve te contactaremos</b></h1>
          <span class="badge-tu-decides">Tú decides, tú lo creas</span>

          <!-- Subtitle -->
          <p class="subtitulo">Compártenos la siguiente información para brindarte atención ágil y personalizada</p>

          <!-- Form -->
          <form @submit.prevent="enviar" class="formulario">
            <div class="grid-2col">
              <!-- Row 1 -->
              <div class="campo">
                <img src="/ejecutivo/nombre completo.png" class="campo-icono" />
                <input v-model="form.nombre_cliente" type="text" placeholder="Nombre completo" required />
              </div>
              <div class="campo">
                <img src="/ejecutivo/RFC.png" class="campo-icono" />
                <input v-model="form.rfc" type="text" placeholder="RFC (opcional)" />
              </div>

              <!-- Row 2 -->
              <div class="campo">
                <img src="/ejecutivo/telefono.png" class="campo-icono" />
                <input v-model="form.telefono" type="tel" placeholder="Teléfono (10 dígitos)" required maxlength="10" @input="soloNumeros" />
                <span v-if="telefonoError" class="campo-hint">{{ telefonoError }}</span>
              </div>
              <div class="campo">
                <img src="/ejecutivo/correo electronico.png" class="campo-icono" />
                <input v-model="form.correo_cliente" type="email" placeholder="Correo electrónico" required />
              </div>

              <!-- Row 3 -->
              <div class="campo">
                <img src="/ejecutivo/ciudad.png" class="campo-icono" />
                <select v-model="form.ciudad" required>
                  <option value="" disabled>Estado</option>
                  <option v-for="e in estados" :key="e" :value="e">{{ e }}</option>
                </select>
              </div>
              <div class="campo">
                <img src="/ejecutivo/cuantas lineas.png" class="campo-icono" />
                <input v-model="form.cuantas_lineas" type="text" placeholder="¿Cuántas líneas requieres?" required @input="soloNumerosLineas" />
              </div>

              <!-- Row 4 -->
              <div class="campo">
                <img src="/ejecutivo/nombre empresa.png" class="campo-icono" />
                <input v-model="form.empresa" type="text" placeholder="Nombre de tu empresa" required />
              </div>
              <div class="campo">
                <img src="/ejecutivo/cuanto pagas.png" class="campo-icono" />
                <input v-model="form.cuanto_pagas" type="text" placeholder="¿Cuánto pagas actualmente por línea?" required @input="soloNumerosPago" />
              </div>

              <!-- Row 5 - Comentarios (full width) -->
              <div class="campo campo-full">
                <img src="/ejecutivo/comentarios.png" class="campo-icono" />
                <input v-model="form.observaciones" type="text" placeholder="Comentarios" />
              </div>
            </div>

            <!-- CAC dropdown (full width, separate) -->
            <div class="campo campo-cac">
              <img src="/ejecutivo/centro de atencion.png" class="campo-icono" />
              <select v-model="form.cac_visitado" required :disabled="!form.ciudad || cargandoCacs">
                <option value="" disabled>{{ cargandoCacs ? 'Cargando...' : 'Centro de Atención y Ventas Movistar que visitaste' }}</option>
                <option v-for="cac in centros" :key="cac" :value="cac">{{ cac }}</option>
              </select>
            </div>

            <!-- Aviso de privacidad -->
            <div class="privacidad-wrap">
              <p class="privacidad-texto">
                Al proporcionar tus datos, aceptas y reconoces haber leído el correspondiente Aviso de Privacidad,
                disponible para su consulta en:
                <a href="https://www.movistar.com.mx/informacion-para-clientes/aviso-de-privacidad" target="_blank" class="privacidad-link">Aviso de Privacidad Integral para Clientes - Movistar México</a>
              </p>
            </div>

            <p v-if="error" class="error">{{ error }}</p>
            <button type="submit" class="btn-enviar" :disabled="loading">
              {{ loading ? 'Enviando...' : 'Enviar' }}
            </button>
          </form>

          <!-- Footer: Sí, es posible -->
          <div class="footer-posible">
            <span class="footer-text">Sí, es posible</span>
          </div>
        </template>

        <!-- ========== SUCCESS VIEW ========== -->
        <div v-else class="success-content">
          <div class="success-panel">
            <img src="/ejecutivo/icono ok.png" alt="OK" class="ok-icon" />
            <h2 class="ok-titulo">Registro exitoso</h2>
            <p class="ok-texto">
              En un lapso de 24 horas, uno de nuestros consultores se pondrá en contacto
              vía telefónica contigo para brindarte atención ágil y personalizada.
            </p>
            <button class="btn-enviar btn-nuevo-style" @click="nuevoRegistro">Nuevo registro</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      form: {
        nombre_cliente: '',
        telefono: '',
        empresa: '',
        rfc: '',
        correo_cliente: '',
        cuantas_lineas: '',
        cuanto_pagas: '',
        observaciones: '',
        ciudad: '',
        cac_visitado: ''
      },
      estados: [],
      centros: [],
      cargandoCacs: false,
      registroExitoso: false,
      loading: false,
      error: '',
      telefonoError: '',
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/ejecutivo/fondo_actual_movil1.jpg' : '/ejecutivo/fondo_actual_pc1.jpg';
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'left center'
      }
    }
  },
  watch: {
    'form.ciudad'(nuevaCiudad) {
      if (nuevaCiudad) {
        this.cargarCacs(nuevaCiudad);
      } else {
        this.centros = [];
        this.form.cac_visitado = '';
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.cargarEstados();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    soloNumeros() {
      this.form.telefono = this.form.telefono.replace(/[^0-9]/g, '');
    },
    soloNumerosLineas() {
      this.form.cuantas_lineas = this.form.cuantas_lineas.replace(/[^0-9]/g, '');
    },
    soloNumerosPago() {
      this.form.cuanto_pagas = this.form.cuanto_pagas.replace(/[^0-9]/g, '');
    },
    async cargarEstados() {
      try {
        const res = await this.$api.get('ejecutivo/estados');
        if (res.data.success) {
          this.estados = res.data.data;
        }
      } catch (err) {
        this.estados = [];
      }
    },
    async cargarCacs(estado) {
      this.cargandoCacs = true;
      this.centros = [];
      this.form.cac_visitado = '';
      try {
        const res = await this.$api.get(`ejecutivo/cacs/${encodeURIComponent(estado)}`);
        if (res.data.success) {
          this.centros = res.data.data;
        }
      } catch (err) {
        this.centros = [];
      } finally {
        this.cargandoCacs = false;
      }
    },
    async enviar() {
      this.error = '';
      this.telefonoError = '';

      // Validar telefono: solo numeros y 10 digitos
      if (!/^\d{10}$/.test(this.form.telefono)) {
        this.telefonoError = 'El teléfono debe ser de 10 dígitos numéricos';
        return;
      }

      // Validar email
      if (this.form.correo_cliente) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.correo_cliente)) {
          this.error = 'Ingresa un correo electrónico válido';
          return;
        }
      }

      this.loading = true;
      try {
        const payload = {
          ...this.form,
          origen: 'web'
        };
        const res = await this.$api.post('ejecutivo/lead', payload);
        if (res.data.success) this.registroExitoso = true;
      } catch (err) {
        this.error = (err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : 'Error al enviar, intenta de nuevo';
      } finally {
        this.loading = false;
      }
    },
    nuevoRegistro() {
      this.form = {
        nombre_cliente: '', telefono: '', empresa: '', rfc: '',
        correo_cliente: '', cuantas_lineas: '', cuanto_pagas: '',
        observaciones: '', ciudad: '', cac_visitado: ''
      };
      this.registroExitoso = false;
      this.error = '';
      this.telefonoError = '';
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  position: relative;
}

/* ============================
   LINK SITIO - bottom left
   ============================ */
.link-sitio {
  position: absolute;
  bottom: 80px;
  left: 20%;
  transform: translateX(-50%);
  color: rgba(255,255,255,0.7);
  font-size: clamp(14px, 1.2vw, 17px);
  font-family: TelefonicaRegular, sans-serif;
  text-decoration: none;
  z-index: 10;
}
.link-sitio:hover {
  color: #fff;
  text-decoration: underline;
}

/* ============================
   PANEL HEADER
   ============================ */
.panel-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: clamp(16px, 2vw, 32px);
}

.panel-logo {
  height: clamp(50px, 5vw, 80px);
  width: auto;
}

/* ============================
   MAIN
   ============================ */
.main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 clamp(20px, 3vw, 60px) 20px;
  margin-left: clamp(300px, 46vw, 800px);
  min-width: 0;
  box-sizing: border-box;
}

.panel {
  width: 100%;
  max-width: 680px;
  min-width: 320px;
}

/* ============================
   TITLE & BADGE
   ============================ */
.titulo {
  color: #fff;
  font-size: clamp(22px, 2.5vw, 38px);
  margin: 0 0 10px;
  line-height: 1.2;
  font-family: TelefonicaBold, TelefonicaRegular, sans-serif;
  white-space: nowrap;
}

.badge-tu-decides {
  display: inline-block;
  background: #019DF4;
  color: #fff;
  font-size: clamp(10px, 0.85vw, 14px);
  padding: clamp(4px, 0.4vw, 8px) clamp(14px, 1.2vw, 22px);
  border-radius: 4px;
  font-family: TelefonicaRegular, sans-serif;
  margin-bottom: clamp(8px, 1vw, 16px);
}

/* ============================
   SUBTITLE
   ============================ */
.subtitulo {
  color: rgba(255,255,255,0.75);
  font-size: clamp(13px, 1.1vw, 17px);
  margin: clamp(10px, 1.2vw, 18px) 0 clamp(14px, 1.6vw, 24px);
  font-family: TelefonicaLight, sans-serif;
}

/* ============================
   FORM - 2 COLUMN GRID
   ============================ */
.formulario {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.grid-2col {
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(10px, 1.2vw, 18px);
}

.campo {
  position: relative;
}

.campo-full {
  grid-column: 1 / -1;
}

.campo-cac {
  position: relative;
  width: 90%;
  margin-top: clamp(10px, 1.2vw, 18px);
}

.campo-icono {
  position: absolute;
  left: clamp(12px, 1vw, 18px);
  top: 50%;
  transform: translateY(-50%);
  width: clamp(14px, 1.2vw, 20px);
  height: clamp(14px, 1.2vw, 20px);
  object-fit: contain;
  filter: brightness(0);
  opacity: 0.3;
  z-index: 1;
}

.campo input,
.campo select {
  width: 100%;
  padding: clamp(10px, 0.8vw, 14px) clamp(14px, 1vw, 20px) clamp(10px, 0.8vw, 14px) clamp(34px, 2.8vw, 46px);
  border: none;
  border-radius: 30px;
  font-size: clamp(11px, 0.85vw, 14px);
  outline: none;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  font-family: TelefonicaRegular, sans-serif;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.campo select {
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 36px;
}

.campo select option[value=""][disabled] {
  color: #aaa;
}

.campo input::placeholder {
  color: #aaa;
  font-size: clamp(11px, 0.85vw, 14px);
}

.campo input:focus,
.campo select:focus {
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(100, 180, 255, 0.4);
}

/* ============================
   CAMPO OBLIGATORIO
   ============================ */
.campo-obligatorio {
  display: block;
  color: rgba(255,255,255,0.5);
  font-size: clamp(9px, 0.6vw, 11px);
  margin-top: 2px;
  padding-left: clamp(34px, 2.8vw, 46px);
  font-family: TelefonicaLight, sans-serif;
  font-style: italic;
}

/* ============================
   CAMPO HINT (debajo del campo)
   ============================ */
.campo-hint {
  display: block;
  color: rgba(255,255,255,0.85);
  font-size: clamp(10px, 0.7vw, 12px);
  margin-top: 4px;
  padding-left: clamp(34px, 2.8vw, 46px);
  font-family: TelefonicaLight, sans-serif;
}

/* ============================
   ERROR
   ============================ */
.error {
  color: #ff6b6b;
  text-align: center;
  font-size: 12px;
  margin: 8px 0 0;
}

/* ============================
   BUTTON ENVIAR
   ============================ */
.btn-enviar {
  width: clamp(120px, 12vw, 200px);
  padding: clamp(8px, 0.6vw, 12px);
  border: none;
  border-radius: 30px;
  background: #E535AB;
  color: #fff;
  font-size: clamp(12px, 0.9vw, 15px);
  cursor: pointer;
  transition: background 0.25s;
  margin-top: clamp(18px, 2vw, 30px);
  align-self: center;
  margin-left: -5%;
  font-family: TelefonicaRegular, sans-serif;
}
.btn-enviar:hover { background: #c92d96; }
.btn-enviar:disabled { opacity: 0.6; cursor: not-allowed; }

/* ============================
   FOOTER - Sí, es posible
   ============================ */
.footer-posible {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: clamp(20px, 2.5vw, 40px);
  gap: clamp(8px, 0.8vw, 14px);
}

.footer-logo {
  height: clamp(30px, 3vw, 50px);
  width: auto;
}

.footer-text {
  color: #fff;
  font-size: clamp(14px, 1.3vw, 20px);
  font-family: TelefonicaRegular, sans-serif;
  font-style: normal;
}

/* ============================
   AVISO DE PRIVACIDAD
   ============================ */
.privacidad-wrap {
  width: 90%;
  margin: 10px 0 0;
  text-align: center;
}
.privacidad-texto {
  color: rgba(255,255,255,0.75);
  font-size: clamp(10px, 0.75vw, 12px);
  font-family: TelefonicaLight, sans-serif;
  line-height: 1.6;
  margin: 0;
}
.privacidad-link {
  color: #00c8f0;
  text-decoration: underline;
}
.privacidad-link:hover {
  color: #fff;
}

/* ============================
   SUCCESS VIEW
   ============================ */
.success-content {
  display: flex;
  justify-content: center;
  padding-top: clamp(30px, 4vw, 60px);
}
.success-panel {
  text-align: center;
  max-width: 520px;
  width: 90%;
}
.ok-icon {
  width: clamp(60px, 6vw, 90px);
  height: clamp(60px, 6vw, 90px);
  margin-bottom: 18px;
}
.ok-titulo {
  color: #fff;
  font-size: clamp(28px, 2.8vw, 42px);
  margin: 0 0 18px;
}
.ok-texto {
  color: rgba(255,255,255,0.8);
  font-size: clamp(14px, 1.2vw, 18px);
  line-height: 1.75;
  max-width: 500px;
  margin: 0 auto 32px;
  font-family: TelefonicaLight, sans-serif;
}
.btn-nuevo-style {
  margin-top: 0;
  margin-left: 0;
  align-self: auto;
}

/* ============================
   TABLET (769 - 1024)
   ============================ */
/* Laptop pequeña / tablet horizontal (769–1280px) */
@media (min-width: 769px) and (max-width: 1280px) {
  .main {
    margin-left: 36vw;
    padding: 0 clamp(16px, 2vw, 40px) 20px;
  }
  .panel {
    max-width: 580px;
  }
}

/* Laptop mediana (1281–1440px) */
@media (min-width: 1281px) and (max-width: 1440px) {
  .main {
    margin-left: 42vw;
    padding: 0 clamp(16px, 2vw, 40px) 20px;
  }
  .panel {
    max-width: 620px;
  }
}

/* ============================
   MOBILE (<= 768)
   ============================ */
@media (max-width: 768px) {
  .page {
    flex-direction: column;
  }

  .panel-header {
    margin-bottom: 40vh;
    justify-content: center;
  }

  .panel-logo {
    height: auto;
    width: 220px;
  }

  .main {
    align-items: center;
    justify-content: flex-start;
    margin-left: 0;
    padding: 24px 20px 30px;
  }

  .panel {
    width: 100%;
    max-width: 400px;
    min-width: 0;
    margin: 0 auto;
  }

  .titulo {
    font-size: 18px;
    white-space: normal;
    margin: 0 0 10px;
    text-align: center;
  }

  .badge-tu-decides {
    font-size: 11px;
    padding: 4px 14px;
    display: block;
    text-align: center;
  }

  .subtitulo {
    font-size: 12px;
    margin: 8px 0 12px;
    text-align: center;
  }

  .grid-2col {
    grid-template-columns: 1fr;
    gap: 8px;
    width: 100%;
  }

  .campo-cac {
    width: 100%;
  }

  .campo-icono {
    left: 14px;
    width: 15px;
    height: 15px;
  }
  .campo input,
  .campo select {
    padding: 10px 16px 10px 40px;
    font-size: 13px;
  }
  .campo input::placeholder {
    font-size: 13px;
  }

  .error {
    text-align: center;
    width: 100%;
  }

  .campo-hint {
    text-align: center;
    padding-left: 0;
  }

  .btn-enviar {
    width: 55%;
    padding: 9px;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
  }

  .formulario {
    align-items: center;
  }

  .footer-posible {
    justify-content: center;
    margin-top: 16px;
  }
  .footer-logo {
    height: 28px;
  }
  .footer-text {
    font-size: 13px;
  }

  .privacidad-wrap {
    width: 100%;
    margin: 8px 0 0;
    text-align: center;
  }
  .privacidad-texto {
    font-size: 11px;
  }

  .link-sitio {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    text-align: center;
  }

  /* Success mobile */
  .success-content {
    padding-top: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
  }
  .success-panel {
    text-align: center;
    width: 90%;
    max-width: 340px;
    margin: 0 auto;
  }
  .ok-icon {
    width: 60px;
    height: 60px;
  }
  .ok-titulo {
    font-size: 22px;
  }
  .ok-texto {
    font-size: 13px;
    padding: 0 10px;
  }
  .btn-nuevo-style {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
</style>
